import * as React from 'react';
import {Query} from 'react-apollo';

import type {
    GetLeadCardFields as GetLeadCardFieldsQuery,
    GetLeadCardFieldsVariables as GetLeadCardFieldsQueryVariables,
    GetLeadCardFields_leadCardFields as SelectableField,
} from 'nutshell-graphql-types';

import GET_LEAD_CARD_FIELDS from './queries/get-lead-card-fields.graphql';

type OwnProps = {
    children: (arg1: ChildrenProps) => React.ReactElement;
    stagesetId: string | null | undefined;
};

type ChildrenProps = {
    fieldsToDisplay: SelectableField[];
    isLoadingFields: boolean;
};

class LeadCardFieldsQuery extends Query<GetLeadCardFieldsQuery, GetLeadCardFieldsQueryVariables> {}

export const GetLeadCardFields = (props: OwnProps) => {
    return (
        <LeadCardFieldsQuery
            query={GET_LEAD_CARD_FIELDS}
            skip={!props.stagesetId}
            // @ts-expect-error
            variables={{stagesetId: props.stagesetId}}
            // @ts-expect-error
            fetchPolicy='cache-and-network'
        >
            {({data, loading}) => {
                const leadCardFields = data ? data.leadCardFields : null;

                return props.children({
                    fieldsToDisplay: leadCardFields || [],
                    isLoadingFields: loading,
                });
            }}
        </LeadCardFieldsQuery>
    );
};
